(function () {
  const LINE_COUNT = 3;

  function measureAndSet(wrapper) {
    const content = wrapper.querySelector("[data-readmore-content]");
    const toggle = wrapper.querySelector("[data-readmore-toggle]");
    if (!content || !toggle) return;

    // Start collapsed by default
    wrapper.classList.add("is-collapsed");
    toggle.textContent = "Read more";

    // We can only measure after the details is open (has layout)
    requestAnimationFrame(() => {
      const overflow = content.scrollHeight > content.clientHeight + 2;
      toggle.hidden = !overflow;
    });
  }

  function init(wrapper) {
    const toggle = wrapper.querySelector("[data-readmore-toggle]");
    if (!toggle) return;

    // Find the parent <details> (Shopify accordion)
    const details = wrapper.closest("details");

    // Measure when accordion opens
    if (details) {
      details.addEventListener("toggle", () => {
        if (details.open) measureAndSet(wrapper);
      });

      // If already open on load (rare), measure now
      if (details.open) measureAndSet(wrapper);
    } else {
      // Not inside details – measure immediately
      measureAndSet(wrapper);
    }

    toggle.addEventListener("click", () => {
      const collapsed = wrapper.classList.toggle("is-collapsed");
      toggle.textContent = collapsed ? "Read more" : "Read less";
    });
  }

  function boot(root = document) {
    root.querySelectorAll("[data-readmore]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", () => boot());
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();